// Métricas por dia dos gráficos do dashboard. A agregação por dia agora vem do
// back (GET /v1/calls/summary → perDay, no fuso da operação), sem puxar as
// chamadas cruas. Aqui só preenchemos os dias vazios do intervalo e derivamos o
// tempo médio geral do período. Puro e sem React.
import { eachDayOfInterval, format } from "date-fns";

// Ponto da série diária: total de chamadas, desfechos (atendidas/falhas/não
// atendidas) e tempo médio (s) das atendidas. Os desfechos alimentam a tela de
// Saúde das ligações; o dashboard usa só total/avgSec.
export interface DayMetric {
  day: string;
  total: number;
  completed: number;
  failed: number;
  noAnswer: number;
  avgSec: number | null;
  // Ligações que chegaram a 3 e a 7 minutos (Saúde das ligações).
  reached3Min?: number;
  reached7Min?: number;
  // Contato humano e não atendidas pela tabulação (Saúde das ligações).
  humanContacts?: number;
  unanswered?: number;
}

// Rótulos YYYY-MM-DD de cada dia do intervalo [from, to] (inclusive).
function daysInRange(from: Date, to: Date): string[] {
  if (to < from) return [];
  return eachDayOfInterval({ start: from, end: to }).map((d) => format(d, "yyyy-MM-dd"));
}

// Preenche a série do back (esparsa — só dias com chamada) com TODOS os dias do
// intervalo: dias sem chamada entram com total 0 e avgSec null. Assim os
// gráficos têm um ponto por dia, sem buracos.
export function fillPerDay(perDay: DayMetric[], from: Date, to: Date): DayMetric[] {
  const byDay = new Map(perDay.map((d) => [d.day, d]));
  return daysInRange(from, to).map(
    (day) =>
      byDay.get(day) ?? {
        day,
        total: 0,
        completed: 0,
        failed: 0,
        noAnswer: 0,
        avgSec: null,
      },
  );
}

// Tempo médio (s) do período inteiro, a partir do summary por agente.
// Σ totalDurationSec / Σ completed. Null quando não houve nenhuma atendida.
export function overallAvgDuration(summary: {
  byAgent: { completed: number; totalDurationSec: number }[];
}): number | null {
  let sum = 0;
  let n = 0;
  for (const agent of summary.byAgent) {
    sum += agent.totalDurationSec;
    n += agent.completed;
  }
  return n > 0 ? Math.round(sum / n) : null;
}
